import { StringSchema } from 'yup'

export default function (this: StringSchema, message: string) {
  return this.test('atLeastOneNumber', message, (value) => /\d/.test(value))
}
